// ══════════════════════════════════════════════════════
// PeptideVault v6.6 — Diagnostics Center + Debug Log (BN45+46)
// ══════════════════════════════════════════════════════
function renderDiagnosticsTab() {
  var debugLog = S._debugLog || []
  var info = {
    version: typeof APP_VERSION !== 'undefined' ? APP_VERSION : '?',
    schema: S._schemaVersion || 1,
    platform: typeof isElectron !== 'undefined' && isElectron ? 'Electron' : 'PWA',
    userAgent: navigator.userAgent.slice(0, 80),
    storage: S.settings.dataDir || 'Default',
    dbSize: JSON.stringify(S).length,
    syncKeys: typeof SYNC_KEYS !== 'undefined' ? SYNC_KEYS.length : '?',
    tabs: 36,
    online: navigator.onLine,
    lastPush: S.lastSyncPush || 'Never',
    lastPull: S.lastSyncPull || 'Never',
    cloud: S.settings.cloudUrl ? 'Configured' : 'None'
  }
  var diagText = Object.keys(info).map(function(k) { return k + ': ' + info[k] }).join('\n')

  return '<div class="tab-content" style="animation:fadeIn .25s ease">' +
    '<div class="row" style="margin-bottom:16px"><h2 style="font-size:20px;font-weight:700">Diagnostics</h2><div class="spacer"></div>' +
    '<button class="btn btn-secondary btn-sm" onclick="copyDiagnostics()">Copy Diagnostics</button></div>' +
    '<div class="card" style="padding:14px;margin-bottom:12px"><div style="font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase;margin-bottom:6px">System Info</div>' +
      '<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(160px,1fr));gap:8px">' +
        Object.keys(info).map(function(k) {
          return '<div style="font-size:12px"><span style="color:var(--text4)">' + k + ':</span> <b>' + esc(String(info[k]).slice(0, 50)) + '</b></div>'
        }).join('') +
      '</div></div>' +
    '<div class="card" style="padding:14px"><div style="display:flex;align-items:center;gap:8px;margin-bottom:6px"><div style="font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase">Debug Log</div><div class="spacer"></div>' +
      '<button class="btn btn-ghost btn-xs" onclick="S._debugLog=[];render()">Clear</button></div>' +
      (debugLog.length === 0 ? '<div style="font-size:12px;color:var(--text4)">No events logged</div>' :
        '<div style="max-height:300px;overflow-y:auto;font-family:monospace;font-size:11px;line-height:1.6">' +
          debugLog.slice(-50).reverse().map(function(e) {
            var color = e.level === 'error' ? 'var(--red)' : e.level === 'warn' ? 'var(--amber)' : 'var(--text3)'
            return '<div style="color:' + color + '">[' + (e.ts || '').slice(11, 19) + '] ' + esc(e.code || '') + ' ' + esc(e.message || '') + '</div>'
          }).join('') +
        '</div>') +
    '</div>' +
  '</div>'
}
function debugLogEvent(level, code, message) {
  if (!S._debugLog) S._debugLog = []
  S._debugLog.push({ ts: now(), level: level, code: code, message: message })
  if (S._debugLog.length > 200) S._debugLog = S._debugLog.slice(-200)
}
function copyDiagnostics() {
  var info = { version: typeof APP_VERSION !== 'undefined' ? APP_VERSION : '?', schema: S._schemaVersion || 1, platform: typeof isElectron !== 'undefined' && isElectron ? 'Electron' : 'PWA', online: navigator.onLine, dbSizeBytes: JSON.stringify(S).length, lastPush: S.lastSyncPush || 'Never', lastPull: S.lastSyncPull || 'Never' }
  var text = 'PeptideVault Diagnostics\n' + Object.keys(info).map(function(k) { return k + ': ' + info[k] }).join('\n')
  navigator.clipboard.writeText(text).then(function() { showToast('Copied') }).catch(function() { showToast('Copy failed') })
}
export { renderDiagnosticsTab, debugLogEvent, copyDiagnostics }
